/**
 * Stats monitoring prefix.
 * @type {String}
 */
export const PREFIX = 'profile';
